export default __webpack_public_path__ + "dd54e4e4b069cb73d0b410cdba8744ab.svg";